<template>
    <svg :width="size" :height="Number(size) + 1" viewBox="0 0 13 14" :fill="color" xmlns="http://www.w3.org/2000/svg" class="paper-with-folded-corner">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.96777 0.328105V2.5C6.96777 4.46751 8.56276 6.0625 10.5303 6.0625H12.7022C12.7537 6.28374 12.7803 6.51182 12.7803 6.74264V10.75C12.7803 12.4069 11.4371 13.75 9.78027 13.75H3.78027C2.12342 13.75 0.780273 12.4069 0.780273 10.75V3.25C0.780273 1.59315 2.12342 0.25 3.78027 0.25H6.28763C6.51845 0.25 6.74653 0.276601 6.96777 0.328105ZM8.09277 0.853849V2.5C8.09277 3.84619 9.18408 4.9375 10.5303 4.9375H12.1764C12.0928 4.82646 12.001 4.72076 11.9016 4.62132L8.40895 1.12868C8.30951 1.02924 8.20381 0.937501 8.09277 0.853849ZM3.21777 7C3.21777 6.68934 3.46961 6.4375 3.78027 6.4375H6.78027C7.09093 6.4375 7.34277 6.68934 7.34277 7C7.34277 7.31066 7.09093 7.5625 6.78027 7.5625H3.78027C3.46961 7.5625 3.21777 7.31066 3.21777 7ZM3.78027 9.4375C3.46961 9.4375 3.21777 9.68934 3.21777 10C3.21777 10.3107 3.46961 10.5625 3.78027 10.5625H9.78027C10.0909 10.5625 10.3428 10.3107 10.3428 10C10.3428 9.68934 10.0909 9.4375 9.78027 9.4375H3.78027Z" :fill="color"/>
</svg>

</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#71767D',
        },
        size: {
            type: String,
            default: 13,
        },
        hoverColor: {
            type: String,
            default: '#4f5357',
        },
    },
};
</script>

<style scoped>
.paper-with-folded-corner:hover path {
    fill: v-bind(hoverColor);
}
</style>